"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    settings: {
        path: "/settings",
    },
    records: {
        path: "/settings/account/records",
    },
    submissionsBuilder: {
        path: "/settings/account/records/submissions-builder/:submissionTypeId?",
    },
    submissionsBuilderV2: {
        path: "/settings/account/records/submissions-builder-v2/:submissionTypeId?",
    },
    propertyData: {
        path: "/settings/account/property-data",
    },
    editSection: {
        path: "/settings/account/property-data/section/:sectionId",
    },
    usersSettings: {
        path: "/settings/users",
    },
    teamSettings: {
        path: "/settings/users/team",
    },
    publicUsersSettings: {
        path: "/settings/users/public",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0dGluZ3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL3NldHRpbmdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsUUFBUSxFQUFFO1FBQ1IsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRCxPQUFPLEVBQUU7UUFDUCxJQUFJLEVBQUUsMkJBQTJCO0tBQ2xDO0lBQ0Qsa0JBQWtCLEVBQUU7UUFDbEIsSUFBSSxFQUFFLGtFQUFrRTtLQUN6RTtJQUNELG9CQUFvQixFQUFFO1FBQ3BCLElBQUksRUFBRSxxRUFBcUU7S0FDNUU7SUFDRCxZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUUsaUNBQWlDO0tBQ3hDO0lBQ0QsV0FBVyxFQUFFO1FBQ1gsSUFBSSxFQUFFLG9EQUFvRDtLQUMzRDtJQUNELGFBQWEsRUFBRTtRQUNiLElBQUksRUFBRSxpQkFBaUI7S0FDeEI7SUFDRCxZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUUsc0JBQXNCO0tBQzdCO0lBQ0QsbUJBQW1CLEVBQUU7UUFDbkIsSUFBSSxFQUFFLHdCQUF3QjtLQUMvQjtDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgc2V0dGluZ3M6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5nc1wiLFxuICB9LFxuICByZWNvcmRzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvYWNjb3VudC9yZWNvcmRzXCIsXG4gIH0sXG4gIHN1Ym1pc3Npb25zQnVpbGRlcjoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2FjY291bnQvcmVjb3Jkcy9zdWJtaXNzaW9ucy1idWlsZGVyLzpzdWJtaXNzaW9uVHlwZUlkP1wiLFxuICB9LFxuICBzdWJtaXNzaW9uc0J1aWxkZXJWMjoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2FjY291bnQvcmVjb3Jkcy9zdWJtaXNzaW9ucy1idWlsZGVyLXYyLzpzdWJtaXNzaW9uVHlwZUlkP1wiLFxuICB9LFxuICBwcm9wZXJ0eURhdGE6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9hY2NvdW50L3Byb3BlcnR5LWRhdGFcIixcbiAgfSxcbiAgZWRpdFNlY3Rpb246IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9hY2NvdW50L3Byb3BlcnR5LWRhdGEvc2VjdGlvbi86c2VjdGlvbklkXCIsXG4gIH0sXG4gIHVzZXJzU2V0dGluZ3M6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy91c2Vyc1wiLFxuICB9LFxuICB0ZWFtU2V0dGluZ3M6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy91c2Vycy90ZWFtXCIsXG4gIH0sXG4gIHB1YmxpY1VzZXJzU2V0dGluZ3M6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy91c2Vycy9wdWJsaWNcIixcbiAgfSxcbn0pO1xuIl19